import React, { memo } from 'react';
import { graphql, usePreloadedQuery, type EntryPointProps } from 'react-relay';
import type { HorizontalNavJiraInnerQuery } from './__generated__/HorizontalNavJiraInnerQuery.graphql';
import JiraHorizontalNavigationContent from './content/JiraHorizontalNavigationContent.tsx';

type Props = EntryPointProps<{ horizontalNavQuery: HorizontalNavJiraInnerQuery }, {}, {}, {}>;

const HorizontalNavJiraInner = ({ queries: { horizontalNavQuery } }: Props): React.JSX.Element => {
	/*
	 * Keep this component as small as possible! Ideally, it is so small that all it does is call usePreloadedQuery,
	 * spread JiraHorizontalNavigationContent and the response into into JiraHorizontalNavigationContent.
	 *
	 * This means we don't run into the issue of having to import the compiled query into mocks, which means you can't add
	 * @relay_test_operation to the query in the test/storybook, which can create hard-to-solve mock issues like this one:
	 * https://hello.atlassian.net/wiki/x/FzuK1w
	 * */
	const data = usePreloadedQuery<HorizontalNavJiraInnerQuery>(
		graphql`
			query HorizontalNavJiraInnerQuery(
				$cloudId: ID!
				$containerNavigationInput: JiraContainerNavigationQueryInput!
				$first: Int!
				$projectIdOrKey: String!
				$withProject: Boolean!
				$boardId: ID!
				$withBoard: Boolean!
				$isTMPBoardRoute: Boolean!
			) @preloadable {
				...JiraHorizontalNavigationContent
			}
		`,
		horizontalNavQuery,
	);

	return <JiraHorizontalNavigationContent queryRef={data} />;
};

export default memo(HorizontalNavJiraInner);
